<div>
  <nz-layout [ngClass]="{
    'cui__layout__contentMaxWidth': isContentMaxWidth,
    'cui__layout__appMaxWidth': isAppMaxWidth,
    'cui__layout__grayBackground': isGrayBackground,
    'cui__layout__squaredBorders': isSquaredBorders,
    'cui__layout__cardsShadow': isCardShadow,
    'cui__layout__borderless': isBorderless
  }">

    <!-- left menu -->
    <!-- FIX: nz-sider wrapper fix layout behaviour in case when menu-left root tag breaks layout transformation -->
    <ng-container *ngIf="!isMobileView; else mobileMenuTmpl">
      <nz-sider [nzWidth]="isMenuCollapsed ? 80 : 120" style="transition: none !important">
        <app-menu-left></app-menu-left>
      </nz-sider>
    </ng-container>
    <ng-template #mobileMenuTmpl>
      <div class="handler" (click)="toggleMobileMenu()">
        <div class="handlerIcon"></div>
      </div>
      <nz-drawer
        nzPlacement="left"
        [nzClosable]="false"
        [nzWrapClassName]="'mobileMenu'"
        [nzVisible]="isMobileMenuOpen"
        [nzWidth]="'120px'"
        (nzOnClose)="toggleMobileMenu()">
        <ng-container *nzDrawerContent>
          <app-menu-left [is4Mobile]="true"></app-menu-left>
        </ng-container>
      </nz-drawer>
    </ng-template>

    <nz-layout>
      <nz-header>
        <app-notify-user></app-notify-user>
        <app-topbar></app-topbar>
      </nz-header>
      <app-menu-top-second></app-menu-top-second>
      <nz-content style="height: 100%; position: relative;">
        <div id="content-main-layout" class="cui__utils__content">
          <router-outlet></router-outlet>
        </div>
      </nz-content>
      <nz-footer>
        <cui-footer></cui-footer>
      </nz-footer>
    </nz-layout>
  </nz-layout>
</div>
